import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/forms"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const templateApi = createApi({
  reducerPath: "templateApi",
  baseQuery: baseQueryWithRejection,
  tagTypes: ["Templates", "Template"],
  endpoints: (builder) => ({
    getTemplates: builder.query({
      query: () => "/",
      transformResponse: (response) => response.data,
      providesTags: ["Templates"],
    }),
    getTemplatesByID: builder.query({
      query: (typeID) => `/?type=${typeID}`,
      transformResponse: (response) => response.data,
      providesTags: ["Templates"],
    }),
    getTemplate: builder.query({
        query: (id) => `/${id}/edit`,
        transformResponse: (response) => response.data,
        providesTags: ["Template"],
    }),
    createTemplate: builder.mutation({
      query: (obj) => ({
        url: `/`,
        method: "POST",
        body: obj,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["Templates"],
    }),
    updateTemplate: builder.mutation({
      query: ({ id, obj }) => ({
        url: `/${id}`,
        method: "PUT",
        body: obj,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["Templates"],
    }),
    deleteTemplate: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["Templates"],
    }),
    changeStatusTemplate: builder.mutation({
      query: (id) => ({
        url: `/${id}/change-status`,
        method: "GET",
      }),
      transformResponse: (response) => response.message,
      invalidatesTags: ["Templates"],
    }),
    saveTemplateProperties: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}/save-properties`,
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["Template"],
    }),
  }),
});

export const {
  useGetTemplatesQuery,
  useDeleteTemplateMutation,
  useChangeStatusTemplateMutation,
  useUpdateTemplateMutation,
  useCreateTemplateMutation,
  useGetTemplatesByIDQuery,
  useGetTemplateQuery,
  useSaveTemplatePropertiesMutation
} = templateApi;
